// Thin wrapper around Umami's window.umami.track()
// Safe to call even if the script hasn't loaded yet.
const emit = (eventName, data) => {
  try {
    if (window.umami) window.umami.track(eventName, data);
  } catch (_) {}
};

export const trackLogin = (username) =>
  emit('login', { username });

export const trackPlay = (track) =>
  emit('play', {
    title: track.title,
    artist: track.artist_name,
    album: track.album_title,
    year: track.year,
  });

export const trackSkip = (track) =>
  emit('skip', {
    title: track.title,
    artist: track.artist_name,
  });
